import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.index-of.js";
var _excluded = ["children"];
var _effectorFileName = "/builds/gmini/front-common/src/classifier-service/ClassifierService/ClassifierService.ts";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.find.js";
import { combine, merge, forward, createEvent, sample } from 'effector';
import { useStoreMap, createGate } from 'effector-react';
import { prop, map, mergeRight, pick } from 'ramda';
import produce from 'immer';
import { createChildDomain, isNotEmpty, isNumber, isEmpty, assertNever, or } from '@gmini/utils';
import * as api from '@gmini/sm-api-sdk';
import { BimElementReferenceItems } from '@gmini/sm-api-sdk';
import * as n from "../Node";
import { adapter, apiToNodeTypeMap } from "../adapters";
import { getUpdateNodesMap, buildKey } from "../ClassifierService/DependenciesService";
import { isIOTSErrorResult, isJsendBadResultFail } from "../ApiService";
import { updateChildItems } from "./updateChildItems";
import { baseTypesMap } from "./BaseTypesMap";
import { updateItem, updateItems } from "./updateItem";
import { updateNodeWithChildren } from "./updateNodeWithChildren";
import { setNode } from "./setNode";
import { updateItemWithChildren } from "./updateItemWithChildren";
import { removeChildFromNode } from "./removeChildFromNode";
import { removeChildFromAll } from "./removeChildFromAll";
import { addChild } from "./addChild";
import { removeItem } from "./removeItem";
import { addChildToNode } from "./addChildToNode";
import { itemPropsUpdate } from "./itemPropsUpdate";
import { itemsPropsUpdate } from "./itemsPropsUpdate";
import { addNode } from "./addNode";
import { updateWithOldChildren } from "./utils";
import { createDependenciesService } from "./DependenciesService";
import { createDynamicFlatNodeService } from "./DynamicFlatNodeService";
var dependencies = createDependenciesService([api.UserClassifier.fetchFlatListItems.defaultContext, api.UserClassifier.fetchFlatListDependencies.defaultContext]);
var dynamicNodesMap = createDynamicFlatNodeService(api.UserClassifier.fetchDynamicGroupFlatItems.defaultContext);
export function createClassifierService(options) {
  var domain = createChildDomain(options.parentDomain, 'ClassifierService');
  var reset = domain.event('reset', {
    name: "reset",
    sid: "n0ml9"
  });
  var Gate = createGate({
    name: 'Mount',
    domain: domain
  });
  forward({
    ɔ: {
      from: Gate.close,
      to: reset
    },
    config: {
      sid: "-l4zy4l"
    }
  });
  var sourceRemoved = createEvent({
    name: "sourceRemoved",
    sid: "8d7818"
  });
  var notification = domain.event('notification', {
    name: "notification",
    sid: "-t2vnh6"
  });
  var getPayload = prop('payload');
  var incomingCreated = notification.filter({
    fn: api.NotificationEvent.Create.is
  }).map(getPayload);
  var bulkCreated = notification.filter({
    fn: api.NotificationEvent.Create.is
  }).map(getPayload).filter({
    fn: BimElementReferenceItems.is
  });
  var incomingUpdated = notification.filter({
    fn: api.NotificationEvent.Update.is
  }).map(getPayload);
  var incomingRemoved = notification.filter({
    fn: api.NotificationEvent.Remove.is
  }).map(getPayload);
  var created = incomingCreated.filter({
    fn: function fn(payload) {
      return payload.type !== 'BimElementReferenceItems';
    }
  }).filter({
    fn: or(api.UserClassifier.is, api.UserClassifierGroup.is, api.BimReference.is, api.AssemblyClassifier.is)
  });
  var updated = incomingUpdated.filter({
    fn: or(api.BaseClassifier.is, api.UserClassifier.is, api.UserClassifierGroup.is, api.BimReference.is, api.AssemblyClassifier.is)
  });
  var removed = incomingRemoved.filter({
    fn: or(api.UserClassifier.is, api.UserClassifierGroup.is, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    api.BimReference.is, api.AssemblyClassifier.is)
  });
  var nodeCreated = created.map(adapter);
  var nodeUpdated = updated.map(adapter);
  var nodeRemoved = removed.map(adapter);
  var bimModel = createNodeService({
    name: 'bimModel',
    parentDomain: domain
  });
  var bimCategory = createNodeService({
    name: 'bimCategory',
    parentDomain: domain
  });
  var bimFamily = createNodeService({
    name: 'bimFamily',
    parentDomain: domain
  });
  var bimStandardSize = createNodeService({
    name: 'bimStandardSize',
    parentDomain: domain
  });
  var bimElement = createNodeService({
    name: 'bimElement',
    parentDomain: domain
  });
  var reference = createNodeService({
    name: 'reference',
    parentDomain: domain
  });
  var baseClassifier = createNodeService({
    name: 'baseClassifier',
    parentDomain: domain
  });
  var userClassifier = createNodeService({
    name: 'userClassifier',
    parentDomain: domain
  });
  var userClassifierGroup = createNodeService({
    name: 'userClassifierGroup',
    parentDomain: domain
  });
  var dynamicBaseGroup = createNodeService({
    name: 'dynamicBaseGroup',
    parentDomain: domain
  });
  var dynamicGeneratedGroup = createNodeService({
    name: 'dynamicGeneratedGroup',
    parentDomain: domain
  });
  var dynamicBimElementReference = createNodeService({
    name: 'dynamicBimElementReference',
    parentDomain: domain
  });
  var assemblyClassifier = createNodeService({
    name: 'assemblyClassifier',
    parentDomain: domain
  });
  var anonymousClassifier = createNodeService({
    name: 'AnonymousClassifier',
    parentDomain: domain
  });
  var nodes$ = combine({
    ɔ: [{
      BimModelNode: bimModel.nodes$,
      BimCategoryNode: bimCategory.nodes$,
      BimFamilyNode: bimFamily.nodes$,
      BimStandardSizeNode: bimStandardSize.nodes$,
      BimElementNode: bimElement.nodes$,
      ReferenceNode: reference.nodes$,
      BaseClassifierNode: baseClassifier.nodes$,
      UserClassifierNode: userClassifier.nodes$,
      UserClassifierGroupNode: userClassifierGroup.nodes$,
      DynamicBaseGroupNode: dynamicBaseGroup.nodes$,
      DynamicGeneratedGroupNode: dynamicGeneratedGroup.nodes$,
      DynamicBimElementReferenceNode: dynamicBimElementReference.nodes$,
      AssemblyClassifierNode: assemblyClassifier.nodes$,
      AnonymousClassifierNode: anonymousClassifier.nodes$
    }],
    config: {
      name: "nodes$",
      sid: "1m3iw5"
    }
  });
  anonymousClassifier.nodes$.on(dependencies.update.doneData.map(function (_ref) {
    var AnonymousClassifierNode = _ref.AnonymousClassifierNode;
    return AnonymousClassifierNode;
  }), function (state, newState) {
    return _objectSpread(_objectSpread({}, state), newState);
  }).on(merge([api.UserClassifier.fetch.doneData, api.UserClassifier.getMostRecent.doneData], {
    sid: "-xulkr3"
  }).map(prop('sourceClassifiers')).map(function (sourceClassifiers) {
    return sourceClassifiers.filter(api.AnonymousClassifier.is);
  }).map(map(adapter)), updateItems);
  baseClassifier.nodes$.on(dependencies.update.doneData.map(function (_ref2) {
    var BaseClassifierNode = _ref2.BaseClassifierNode;
    return BaseClassifierNode;
  }), function (state, newState) {
    return _objectSpread(_objectSpread({}, state), newState);
  }).on(api.BaseClassifier.Populated.fetch.doneData.map(adapter), function (nodes, baseClassifier) {
    var oldBaseClassifier = nodes[baseClassifier.id];

    if (oldBaseClassifier && oldBaseClassifier.version !== baseClassifier.version) {
      var newNodes = _objectSpread({}, nodes);

      delete newNodes[baseClassifier.id];
      return updateItemWithChildren(newNodes, baseClassifier);
    }

    return updateItemWithChildren(nodes, baseClassifier);
  }).on(merge([api.UserClassifier.fetch.doneData, api.AssemblyClassifier.fetch.doneData, api.AssemblyClassifier.getMostRecent.doneData, api.UserClassifier.getMostRecent.doneData], {
    sid: "-m2o79o"
  }).map(prop('sourceClassifiers')).map(function (sourceClassifiers) {
    return sourceClassifiers.filter(api.BaseClassifier.is);
  }).map(map(adapter)), updateItems).on(updated.filter({
    fn: api.UserClassifier.is
  }).map(prop('sourceClassifiers')).map(function (sourceClassifiers) {
    return sourceClassifiers.filter(api.BaseClassifier.is);
  }).map(map(adapter)), updateItems).on(merge([api.AssemblyClassifier.addDependency.doneData, api.UserClassifier.addDependency.doneData], {
    sid: "-l2ds3u"
  }).map(prop('sourceClassifiers')).map(function (sourceClassifiers) {
    return sourceClassifiers.filter(api.BaseClassifier.is);
  }).map(map(adapter)), updateChildItems).reset(reset);
  var userClassifierUpdatedSocket = updated.map(adapter).filter({
    fn: n.isUserClassifierNode
  }); // Расчитываем diff перед обновлением

  var updatedClassifierWithCalcDiff = sample({
    ɔ: [{
      clock: userClassifierUpdatedSocket,
      source: userClassifier.nodes$,
      fn: function fn(state, node) {
        var prevNode = state[node.id];
        var deletedSources = (prevNode === null || prevNode === void 0 ? void 0 : prevNode.sourceClassifiers.filter(function (prevCls) {
          return !(node !== null && node !== void 0 && node.sourceClassifiers.some(function (cls) {
            return prevCls.id === cls.id;
          }));
        })) || null;
        return {
          node: node,
          deletedSources: deletedSources
        };
      }
    }],
    config: {
      name: "updatedClassifierWithCalcDiff",
      sid: "-jj08g6"
    }
  });
  var updatedClassifier = updatedClassifierWithCalcDiff.map(function (_ref3) {
    var node = _ref3.node;
    return node;
  });
  var removeRefFromGroup = createEvent({
    name: "removeRefFromGroup",
    sid: "uev9k6"
  });
  var removeAssemblyRef = createEvent({
    name: "removeAssemblyRef",
    sid: "ityjz7"
  });
  updatedClassifierWithCalcDiff.map(function (_ref4) {
    var deletedSources = _ref4.deletedSources;
    return deletedSources;
  }).watch(function (deleted) {
    return deleted === null || deleted === void 0 ? void 0 : deleted.forEach(sourceRemoved);
  });
  userClassifier.nodes$.on(dependencies.update.doneData.map(function (_ref5) {
    var UserClassifierNode = _ref5.UserClassifierNode;
    return UserClassifierNode;
  }), function (state, newState) {
    return _objectSpread(_objectSpread({}, state), newState);
  }).on(api.UserClassifier.create.doneData.map(adapter), updateItem).on(api.UserClassifier.copy.doneData.map(adapter), updateItem).on(api.UserClassifier.fetch.doneData.map(adapter), updateItemWithChildren).on(api.UserClassifier.getMostRecent.doneData.map(adapter), updateItemWithChildren).on(api.UserClassifier.fetch.doneData.map(adapter), updateItemWithChildren).on(api.UserClassifier.rename.doneData.map(adapter), updateItem).on(api.UserClassifier.move.doneData.map(adapter), updateItem).on(api.UserClassifier.remove.doneData.map(adapter), removeItem).on(api.UserClassifier.addDependency.doneData.map(adapter), updateItem).on(api.UserClassifier.removeDependency.doneData.map(adapter), updateItem).on(created.map(adapter).filter({
    fn: n.isUserClassifierNode
  }), addNode).on(updatedClassifier, itemPropsUpdate(['name', 'parentFolderId', 'total', 'version', 'versionCreatedDate'])).on(updated.filter({
    fn: api.UserClassifier.is
  }).map(prop('sourceClassifiers')).map(function (sourceClassifiers) {
    return sourceClassifiers.filter(api.UserClassifier.is);
  }).map(map(adapter)), itemsPropsUpdate(['name', 'parentFolderId', 'total', 'version', 'sourceClassifiers'])).on(removed.map(adapter).filter({
    fn: n.isUserClassifierNode
  }), removeItem).on(merge([api.UserClassifierGroup.create.doneData, api.UserClassifierGroup.createGroupReference.doneData], {
    sid: "-6gqgum"
  }).map(adapter), function (nodes, _ref6) {
    var type = _ref6.type,
        id = _ref6.id,
        parentClassifierId = _ref6.parentClassifierId,
        parentGroupId = _ref6.parentGroupId;

    if (isEmpty(parentGroupId)) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return addChild(nodes, parentClassifierId, {
        type: type,
        id: id
      });
    }
  }).on(api.UserClassifierGroup.groupCopying.doneData, function (state, _ref7) {
    var classifierId = _ref7.classifierId,
        userClassifierGroupFlats = _ref7.userClassifierGroupFlats;
    var rootGroups = userClassifierGroupFlats.filter(function (group) {
      return group.parentId === classifierId;
    });

    var nextState = _objectSpread({}, state);

    rootGroups.forEach(function (group) {
      var currentCls = nextState[classifierId];

      if (currentCls !== null && currentCls !== void 0 && currentCls.children.some(function (_ref8) {
        var id = _ref8.id;
        return group.id === id;
      }) || !api.UserClassifierGroup.is(group)) {
        return;
      }

      nextState[classifierId] = _objectSpread(_objectSpread({}, currentCls), {}, {
        children: [].concat(_toConsumableArray((currentCls === null || currentCls === void 0 ? void 0 : currentCls.children) || []), [adapter(group)])
      });
    });
    return nextState;
  }).on(api.UserClassifierGroup.move.doneData.map(adapter), function (nodes, _ref9) {
    var type = _ref9.type,
        id = _ref9.id,
        parentClassifierId = _ref9.parentClassifierId,
        parentGroupId = _ref9.parentGroupId;
    return isNumber(parentGroupId) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    removeChildFromAll(nodes, {
      type: type,
      id: id
    }) : // eslint-disable-next-line @typescript-eslint/no-explicit-any
    addChild(nodes, parentClassifierId, {
      type: type,
      id: id
    });
  }).on(api.UserClassifierGroup.remove.doneData.map(adapter), function (nodes, _ref10) {
    var type = _ref10.type,
        id = _ref10.id;
    return (// eslint-disable-next-line @typescript-eslint/no-explicit-any
      removeChildFromAll(nodes, {
        type: type,
        id: id
      })
    );
  }).on(api.UserClassifier.addDependency.doneData.map(prop('sourceClassifiers')).map(function (sourceClassifiers) {
    return sourceClassifiers.filter(api.UserClassifier.is);
  }).map(map(adapter)), itemsPropsUpdate(['name', 'version', 'parentFolderId', 'total'])).reset(reset);
  assemblyClassifier.nodes$.on(dependencies.update.doneData.map(function (_ref11) {
    var AssemblyClassifierNode = _ref11.AssemblyClassifierNode;
    return AssemblyClassifierNode;
  }), function (state, newState) {
    return _objectSpread(_objectSpread({}, state), newState);
  }).on(api.UserClassifier.getMostRecent.doneData, function (state, payload) {
    var next = _objectSpread({}, state);

    payload.sourceClassifiers.forEach(function (classifier) {
      if (api.AssemblyClassifier.is(classifier)) {
        next[classifier.id] = adapter(classifier);
      }
    });
    return next;
  }).on(api.AssemblyClassifier.create.doneData.map(adapter), updateItem).on(api.AssemblyClassifier.copy.doneData.map(adapter), updateItem).on(api.AssemblyClassifier.fetch.doneData.map(adapter), updateItemWithChildren).on(api.AssemblyClassifier.getMostRecent.doneData.map(adapter), updateItemWithChildren).on(api.AssemblyClassifier.fetch.doneData.map(adapter), updateItemWithChildren).on(api.AssemblyClassifier.rename.doneData.map(adapter), updateItem).on(api.AssemblyClassifier.move.doneData.map(adapter), updateItem).on(api.AssemblyClassifier.remove.doneData.map(adapter), removeItem).on(api.AssemblyClassifier.addDependency.doneData.map(adapter), updateItem).on(api.AssemblyClassifier.removeDependency.doneData.map(adapter), updateItem).on(api.AssemblyClassifier.runAssembly.doneData.map(adapter), updateItem).on(created.map(adapter).filter({
    fn: n.isAssemblyClassifierNode
  }), addNode).on(removed.map(adapter).filter({
    fn: n.isAssemblyClassifierNode
  }), removeItem).on(updated.map(adapter).filter({
    fn: n.isAssemblyClassifierNode
  }), function (state, assembly) {
    var oldAssembly = state[assembly.id];

    if (oldAssembly !== null && oldAssembly !== void 0 && oldAssembly.assemblyModelRef && !assembly.assemblyModelRef) {
      removeAssemblyRef(oldAssembly.assemblyModelRef);
    }

    return state;
  }).on(updated.map(adapter).filter({
    fn: n.isAssemblyClassifierNode
  }), itemPropsUpdate(['name', 'parentFolderId', 'total', 'version', 'sourceClassifiers', 'versionCreatedDate', 'status', 'assemblyModelRef'])).reset(reset);
  {
    var userClassifierGroupNodeFetched = merge([api.UserClassifierGroup.fetch.doneData, api.UserClassifierGroup.create.doneData, api.UserClassifierGroup.createGroupReference.doneData], {
      name: "userClassifierGroupNodeFetched",
      sid: "-amstgy"
    }).map(adapter);
    var userClassifierGroupWithGroupsNodeFetched = userClassifierGroupNodeFetched.filter({
      fn: n.isUserClassifierGroupWithGroupsNode
    });
    var userClassifierGroupWithElementsNodeFetched = userClassifierGroupNodeFetched.filter({
      fn: n.isUserClassifierGroupWithElementsNode
    });
    var userClassifierGroupWithChildrenNodeFetched = merge([userClassifierGroupWithGroupsNodeFetched, userClassifierGroupWithElementsNodeFetched], {
      name: "userClassifierGroupWithChildrenNodeFetched",
      sid: "exirq0"
    });
    var userClassifierEmptyGroupNodeFetched = userClassifierGroupNodeFetched.filter({
      fn: n.isUserClassifierEmptyGroupNode
    });
    var userClassifierGroupRemoved = api.UserClassifierGroup.remove.doneData.map(adapter);
    dynamicBaseGroup.nodes$.on(api.DynamicGroup.fetch.doneData.filter({
      fn: api.DynamicBaseGroup.Populated.is
    }).map(adapter), updateItemWithChildren).on(dynamicNodesMap.update.doneData.map(function (_ref12) {
      var DynamicBaseGroupNode = _ref12.DynamicBaseGroupNode;
      return DynamicBaseGroupNode;
    }), function (state, data) {
      var result = _objectSpread({}, state);

      data.forEach(function (item) {
        result[item.id] = item;
      });
      return result;
    }).on( // extract groups their children
    api.DynamicGroup.fetch.doneData.map(function (g) {
      return g.children;
    }), function (state, payload) {
      return updateWithOldChildren(state, payload.filter(api.DynamicBaseGroup.is).map(function (child) {
        return adapter(child);
      }));
    }).on( // extract groups from UserClassifierPopulated.children[]
    merge([api.UserClassifier.fetch.doneData, api.UserClassifier.getMostRecent.doneData], {
      sid: "ndnimq"
    }), function (state, payload) {
      return updateWithOldChildren(state, payload.children.map(function (gr) {
        return gr.dynamicGroup;
      }).filter(isNotEmpty).map(adapter));
    }).on( // extract groups from UserClassifierGroupPopulated.children[]
    api.UserClassifierGroup.fetch.doneData, function (state, payload) {
      var dynamicGroup = payload.dynamicGroup;

      var next = _objectSpread({}, state);

      if (dynamicGroup && api.DynamicBaseGroup.is(dynamicGroup)) {
        Object.assign(next, updateWithOldChildren(state, adapter(dynamicGroup)));
      }

      if (payload.type !== 'UserClassifierGroupWithGroupsPopulated') {
        return next;
      }

      return updateWithOldChildren(next, payload.children.map(function (n) {
        return n.dynamicGroup;
      }).filter(isNotEmpty).filter(api.DynamicBaseGroup.is).map(adapter));
    }).on(updated.filter({
      fn: api.DynamicBaseGroup.is
    }), function (state, payload) {
      return (// eslint-disable-next-line @typescript-eslint/no-explicit-any
        updateWithOldChildren(state, adapter(payload))
      );
    }).on(api.UserClassifier.removeDependency.done, function (state, _ref13) {
      var params = _ref13.params,
          result = _ref13.result;

      var next = _objectSpread({}, state);

      Object.keys(next).forEach(function (id) {
        var item = next[Number(id)];

        if (item && item.parentClassifierId === params.sourceClassifierId) {
          delete next[Number(id)];
        }
      });
      return next;
    });
    dynamicGeneratedGroup.nodes$.on(api.DynamicGroup.fetch.doneData.filter({
      fn: api.DynamicGeneratedGroup.Populated.is
    }).map(adapter), updateItemWithChildren).on(dynamicNodesMap.update.doneData.map(function (_ref14) {
      var DynamicGeneratedGroupNode = _ref14.DynamicGeneratedGroupNode;
      return DynamicGeneratedGroupNode;
    }), function (state, data) {
      var result = _objectSpread({}, state);

      data.forEach(function (item) {
        result[item.id] = item;
      });
      return result;
    }).on( // extract groups their children
    api.DynamicGroup.fetch.doneData.map(function (g) {
      return g.children;
    }), function (state, payload) {
      return updateWithOldChildren(state, payload.filter(api.DynamicGeneratedGroup.is).map(function (gr) {
        return adapter(gr);
      }));
    }).on( // extract groups from UserClassifierGroupPopulated.children[]
    api.UserClassifierGroup.fetch.doneData, function (state, payload) {
      var dynamicGroup = payload.dynamicGroup;

      var next = _objectSpread({}, state);

      if (dynamicGroup && api.DynamicGeneratedGroup.is(dynamicGroup)) {
        next[dynamicGroup.id] = adapter(dynamicGroup);
      }

      if (payload.type !== 'UserClassifierGroupWithGroupsPopulated') {
        return next;
      }

      return updateWithOldChildren(state, payload.children.map(function (gr) {
        return gr.dynamicGroup;
      }).filter(isNotEmpty).filter(api.DynamicGeneratedGroup.is).map(function (gr) {
        return adapter(gr);
      }));
    }).on(api.UserClassifier.removeDependency.done, function (state, _ref15) {
      var params = _ref15.params,
          result = _ref15.result;

      var next = _objectSpread({}, state);

      Object.keys(next).forEach(function (id) {
        var item = next[Number(id)];

        if (item && item.parentClassifierId === params.sourceClassifierId) {
          delete next[Number(id)];
        }
      });
      return next;
    });
    dynamicBimElementReference.nodes$.on( // extract from GeneratedGroup children
    api.DynamicGroup.fetch.doneData, function (state, payload) {
      var next = _objectSpread({}, state);

      payload.children.filter(api.DynamicBimElementReference.is).forEach(function (r) {
        var old = next[r.id];
        var nextNode = adapter(r);
        var withElement = pick(['element'], old || nextNode);
        next[r.id] = mergeRight(nextNode, withElement);
      });
      return next;
    });
    userClassifierGroup.nodes$.on(api.UserClassifier.removeDependency.done, function (state, _ref16) {
      var sourceClassifierId = _ref16.params.sourceClassifierId;
      var groups = Object.values(state);
      var clsGroups = groups.filter(function (_ref17) {
        var source = _ref17.source;
        return (source === null || source === void 0 ? void 0 : source.sourceClassifierId) === sourceClassifierId;
      });

      if (clsGroups.length) {
        var nextState = _objectSpread({}, state);

        clsGroups.forEach(function (_ref18) {
          var id = _ref18.id;
          delete nextState[id];
        });
        return nextState;
      }

      return state;
    }).on(api.UserClassifier.findElementEverywhere.doneData, function (state, result) {
      var next = _objectSpread({}, state);

      result.elements.forEach(function (element) {
        if (!element.parentGroupId) {
          return;
        }

        var currentGroup = next[element.parentGroupId];

        if ((currentGroup === null || currentGroup === void 0 ? void 0 : currentGroup.type) === 'UserClassifierGroupWithElementsNode') {
          var child = adapter(element);
          var ref = {
            id: child.id,
            type: apiToNodeTypeMap.BimElementReference
          };
          next[element.parentGroupId] = _objectSpread(_objectSpread({}, currentGroup), {}, {
            children: [].concat(_toConsumableArray(currentGroup.children), [ref])
          });
        }
      });
      return next;
    }).on(api.DynamicGroup.fetch.doneData, function (state, payload) {
      if (api.DynamicBaseGroup.Populated.is(payload)) {
        var _group$dynamicGroup;

        var next = _objectSpread({}, state);

        var dynamicGroup = adapter(payload);
        var group = next[payload.sourceGroupId];

        if ((group === null || group === void 0 ? void 0 : (_group$dynamicGroup = group.dynamicGroup) === null || _group$dynamicGroup === void 0 ? void 0 : _group$dynamicGroup.type) === 'DynamicBaseGroupNode' && group.dynamicGroup.children.length) {
          var children = dynamicGroup.children,
              notPopulatedDynamicGroup = _objectWithoutProperties(dynamicGroup, _excluded);

          next[group.id] = _objectSpread(_objectSpread({}, group), {}, {
            dynamicGroup: _objectSpread(_objectSpread({}, notPopulatedDynamicGroup), {}, {
              children: [].concat(_toConsumableArray(group.dynamicGroup.children), _toConsumableArray(children))
            })
          });
          return next;
        } else if (group) {
          next[group.id] = _objectSpread(_objectSpread({}, group), {}, {
            dynamicGroup: dynamicGroup
          });
          return next;
        }

        return next;
      }

      return state;
    }).on(dynamicNodesMap.update.doneData.map(function (_ref19) {
      var DynamicBaseGroupNode = _ref19.DynamicBaseGroupNode;
      return DynamicBaseGroupNode;
    }), function (state, dynamicBaseGroupNodes) {
      var newState = _objectSpread({}, state);

      dynamicBaseGroupNodes.forEach(function (node) {
        var group = newState[node.sourceGroupId];

        if (group) {
          newState = _objectSpread(_objectSpread({}, newState), {}, _defineProperty({}, group.id, _objectSpread(_objectSpread({}, group), {}, {
            dynamicGroup: node
          })));
        }
      });
      return newState;
    }).on(dependencies.update.doneData.map(function (_ref20) {
      var UserClassifierGroupNode = _ref20.UserClassifierGroupNode;
      return UserClassifierGroupNode;
    }), function (state, newState) {
      return _objectSpread(_objectSpread({}, state), newState);
    }).on(merge([api.UserClassifier.fetch.doneData, api.UserClassifier.getMostRecent.doneData], {
      sid: "-5gssh0"
    }).map(prop('children')).map(map(adapter)), updateItems).on(bulkCreated, function (state, _ref21) {
      var parentGroupId = _ref21.parentGroupId,
          bimElementReferences = _ref21.bimElementReferences;

      var nextState = _objectSpread({}, state);

      var group = nextState[parentGroupId];

      if (!group || group.type === 'UserClassifierGroupWithGroupsNode') {
        return state;
      }

      var elementRefs = bimElementReferences.map(adapter).map(function (_ref22) {
        var id = _ref22.id,
            type = _ref22.type;
        return {
          id: id,
          type: type
        };
      });

      if (group.type === 'UserClassifierEmptyGroupNode') {
        group = _objectSpread(_objectSpread({}, toGroupWithElements(group)), {}, {
          total: elementRefs.length
        });
      }

      var children = group.children || [];
      return _objectSpread(_objectSpread({}, nextState), {}, _defineProperty({}, group.id, _objectSpread(_objectSpread({}, group), {}, {
        children: [].concat(_toConsumableArray(children), _toConsumableArray(elementRefs))
      })));
    }).on(api.UserClassifierGroup.fetch.doneData.filter({
      fn: api.UserClassifierGroup.WithGroups.Populated.is
    }).map(prop('children')).map(map(adapter)), updateItems).on(userClassifierGroupWithChildrenNodeFetched, function (nodes, newGroup) {
      return setNode(nodes, newGroup.id, function (oldGroup) {
        if (!oldGroup) {
          return newGroup;
        }

        switch (oldGroup.type) {
          case 'UserClassifierGroupWithGroupsNode':
          case 'UserClassifierGroupWithElementsNode':
            return updateNodeWithChildren(oldGroup, newGroup);

          case 'UserClassifierEmptyGroupNode':
            return newGroup;

          default:
            return assertNever('oldGroup type', oldGroup);
        }
      });
    }).on(userClassifierEmptyGroupNodeFetched, updateItem).on(merge([api.UserClassifierGroup.create.doneData, api.UserClassifierGroup.createGroupReference.doneData, updated], {
      sid: "-2lfgx4"
    }).map(adapter).filter({
      fn: n.isUserClassifierGroupNode
    }), function (nodes, node) {
      if (isNumber(node.parentGroupId)) {
        return setNode(nodes, node.parentGroupId, function (parentGroup) {
          if (!parentGroup) {
            return;
          }

          if (parentGroup.type === 'UserClassifierGroupWithGroupsNode') {
            return addChildToNode(parentGroup, node);
          }

          if (parentGroup.type === 'UserClassifierEmptyGroupNode') {
            return addChildToNode(_objectSpread(_objectSpread({}, parentGroup), {}, {
              type: 'UserClassifierGroupWithGroupsNode',
              total: 1,
              offset: 0,
              children: []
            }), node);
          }
        });
      }
    }).on(merge([api.UserClassifierGroup.rename.doneData.map(adapter), api.UserClassifierGroup.createFilter.doneData.map(adapter), api.UserClassifierGroup.updateFilter.doneData.map(adapter), api.UserClassifierGroup.removeFilter.doneData.map(adapter)], {
      sid: "nygl3v"
    }), updateItem).on(api.UserClassifierGroup.move.doneData.map(adapter), function (nodes, node) {
      var type = node.type,
          id = node.id,
          parentGroupId = node.parentGroupId;
      var withoutChild = // eslint-disable-next-line @typescript-eslint/no-explicit-any
      removeChildFromAll(nodes, {
        type: type,
        id: id
      });
      return setNode(withoutChild, parentGroupId, function (oldParentGroup) {
        if (!oldParentGroup) {
          return;
        }

        switch (oldParentGroup.type) {
          case 'UserClassifierEmptyGroupNode':
            return addChildToNode( //  TODO any
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            toGroupWithGroups(oldParentGroup), {
              type: type,
              id: id
            });

          case 'UserClassifierGroupWithGroupsNode':
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return addChildToNode(oldParentGroup, {
              type: type,
              id: id
            });
        }
      });
    }).on(userClassifierGroupRemoved, function (nodes, _ref23) {
      var type = _ref23.type,
          id = _ref23.id,
          parentGroupId = _ref23.parentGroupId;
      return setNode(nodes, parentGroupId, function (oldGroup) {
        if (oldGroup && oldGroup.type === 'UserClassifierGroupWithGroupsNode') {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          return removeChildFromNode(oldGroup, {
            type: type,
            id: id
          });
        }
      });
    }).on(userClassifierGroupRemoved, function (old, data) {
      return removeItem(old, data);
    }).on(userClassifierGroupRemoved, function (groupNodes, _ref24) {
      var type = _ref24.type,
          id = _ref24.id;
      var withoutChildren = // eslint-disable-next-line @typescript-eslint/no-explicit-any
      removeChildFromAll(groupNodes, {
        type: type,
        id: id
      });
      return withoutChildren;
    }).on(merge([api.BimReference.create.doneData, api.BimReference.move.doneData, created, updated], {
      sid: "qs6ivo"
    }).map(adapter).filter({
      fn: n.isReferenceNode
    }), function (nodes, _ref25) {
      var type = _ref25.type,
          id = _ref25.id,
          parentGroupId = _ref25.parentGroupId;
      var withoutChildren = // eslint-disable-next-line @typescript-eslint/no-explicit-any
      removeChildFromAll(nodes, {
        type: type,
        id: id
      });
      return setNode(withoutChildren, parentGroupId, function (oldNode) {
        if (!oldNode || oldNode.type === 'UserClassifierGroupWithGroupsNode') {
          return;
        }

        if (oldNode.type === 'UserClassifierEmptyGroupNode') {
          return addChildToNode(toGroupWithElements(oldNode), {
            id: id,
            type: type
          });
        }

        var withoutChild = removeChildFromNode(oldNode, {
          id: id,
          type: type
        });
        return addChildToNode(withoutChild, {
          id: id,
          type: type
        });
      });
    }).on(created.map(adapter).filter({
      fn: n.isUserClassifierGroupNode
    }), function (state, group) {
      var id = group.id,
          parentGroupId = group.parentGroupId,
          type = group.type;
      var next = addNode(state, group);

      if (!parentGroupId) {
        return next;
      }

      return setNode(next, parentGroupId, function (oldNode) {
        if (!oldNode) {
          return;
        }

        if (oldNode.type === 'UserClassifierEmptyGroupNode') {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          return addChildToNode(toGroupWithGroups(oldNode), {
            id: id,
            type: type
          });
        } // eslint-disable-next-line @typescript-eslint/no-explicit-any


        return addChildToNode(oldNode, {
          id: id,
          type: type
        });
      });
    }).on(updated.map(adapter).filter({
      fn: n.isUserClassifierGroupNode
    }), function (nodes, node) {
      return (// eslint-disable-next-line @typescript-eslint/no-explicit-any
        itemPropsUpdate(['name', 'type', 'total', 'dynamicGroup'])(nodes, node // eslint-disable-next-line @typescript-eslint/no-explicit-any
        )
      );
    }).on( // при update меняем свойства парента ноды
    updated.map(adapter).filter({
      fn: n.isUserClassifierGroupNode
    }), function (nodes, payload) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      var newNodes = updateWithOldChildren(nodes, payload);

      if (!payload.parentGroupId) {
        return newNodes;
      }

      var oldNode = nodes[payload.id];

      if (oldNode !== null && oldNode !== void 0 && oldNode.parentGroupId && payload.parentGroupId !== (oldNode === null || oldNode === void 0 ? void 0 : oldNode.parentGroupId)) {
        var _withoutChild$childre;

        var parent = nodes[oldNode === null || oldNode === void 0 ? void 0 : oldNode.parentGroupId]; // eslint-disable-next-line @typescript-eslint/no-explicit-any

        var withoutChild = removeChildFromNode(parent, payload);

        if (!((_withoutChild$childre = withoutChild.children) !== null && _withoutChild$childre !== void 0 && _withoutChild$childre.length)) {
          var group = _objectSpread(_objectSpread({}, withoutChild), {}, {
            total: 0,
            children: []
          });

          return setNode(newNodes, group.id, function () {
            return group;
          });
        }

        return setNode(newNodes, withoutChild.id, function () {
          return withoutChild;
        });
      }
    }).on(removed.map(adapter).filter({
      fn: n.isUserClassifierGroupNode
    }), function (nodes, group) {
      var currentGroup = nodes[group.id];

      if (currentGroup && currentGroup.type === 'UserClassifierGroupWithElementsNode' && 'children' in currentGroup) {
        removeRefFromGroup(currentGroup.children);
      }

      return removeItem(nodes, group);
    }).on(sourceRemoved, function (state, sourceCls) {
      return produce(state, function (draft) {
        var groups = Object.values(draft).filter(isNotEmpty);
        var toRemoveGroups = groups.filter(function (group) {
          var _group$source;

          return (group === null || group === void 0 ? void 0 : (_group$source = group.source) === null || _group$source === void 0 ? void 0 : _group$source.sourceClassifierId) === sourceCls.id;
        }); // Удаляем группы

        toRemoveGroups.forEach(function (group) {
          return delete draft[group.id];
        });
        var refs = Object.values(reference.nodes$.getState());
        var toRemoveRefs = refs.filter(function (reference) {
          var _reference$source;

          return ((_reference$source = reference.source) === null || _reference$source === void 0 ? void 0 : _reference$source.sourceClassifierId) === sourceCls.id;
        });
        groups.forEach(function (group) {
          if ('children' in group) {
            var children = group.children;

            if (children.length) {
              var nextChildren = children // Удаляем рефы из children
              .filter(function (_ref26) {
                var id = _ref26.id;
                return !toRemoveRefs.some(function (ref) {
                  return ref.id === id;
                });
              }) // Удаляем группы из children
              .filter(function (_ref27) {
                var id = _ref27.id;
                return !toRemoveGroups.some(function (gr) {
                  return gr.id === id;
                });
              }); // eslint-disable-next-line @typescript-eslint/no-explicit-any

              group.children = nextChildren;

              if (nextChildren.length === 0) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                ;
                group.type = 'UserClassifierEmptyGroupNode'; // eslint-disable-next-line @typescript-eslint/no-explicit-any

                delete group.children; // eslint-disable-next-line @typescript-eslint/no-explicit-any

                delete group.total;
              }
            }
          }
        });
        return draft;
      });
    }).on(api.DynamicGroup.remove.doneData, function (s, p) {
      var group = s[p.sourceGroupId];

      if (group) {
        return _objectSpread(_objectSpread({}, s), {}, _defineProperty({}, p.sourceGroupId, _objectSpread(_objectSpread({}, group), {}, {
          dynamicGroup: null
        })));
      }
    }).on(updated.map(adapter).filter({
      fn: n.isUserClassifierEmptyGroupNode
    }), function (state, emptyGroup) {
      return setNode(state, emptyGroup.id, function () {
        return emptyGroup;
      });
    }).on(removed.map(adapter).filter({
      fn: n.isReferenceNode
    }), function (state, reference) {
      if (!reference.parentGroupId) {
        return state;
      }

      var newState = _objectSpread({}, state);

      var currentGroup = newState[reference.parentGroupId];
      return (currentGroup === null || currentGroup === void 0 ? void 0 : currentGroup.type) === 'UserClassifierGroupWithElementsNode' ? setNode(newState, currentGroup.id, function () {
        return _objectSpread(_objectSpread({}, currentGroup), {}, {
          children: currentGroup.children.filter(function (ref) {
            return ref.id !== reference.id;
          })
        });
      }) : state;
    }).on(api.UserClassifierGroup.groupCopying.defaultContext.doneData, function (state, result) {
      var _getUpdateNodesMap = getUpdateNodesMap(result.userClassifierGroupFlats, buildKey, baseTypesMap, adapter),
          UserClassifierGroupNode = _getUpdateNodesMap.UserClassifierGroupNode;

      return _objectSpread(_objectSpread({}, state), UserClassifierGroupNode);
    }).reset(reset);
  }
  var assemblyModelRef = merge([api.AssemblyClassifier.fetch.doneData, api.AssemblyClassifier.getMostRecent.doneData, api.AssemblyClassifier.runAssembly.doneData, updated], {
    name: "assemblyModelRef",
    sid: "n52ot6"
  }).filter({
    fn: api.AssemblyClassifier.is
  }).map(prop('assemblyModelRef')).filter({
    fn: isNotEmpty
  });
  var childReferencesFetched = merge([api.BaseClassifier.Populated.fetch.doneData.map(prop('children')), api.UserClassifierGroup.fetch.doneData.filter({
    fn: api.UserClassifierGroup.WithElements.Populated.is
  }).map(prop('children'))], {
    name: "childReferencesFetched",
    sid: "8cb09x"
  });
  reference.nodes$.on(dependencies.update.doneData.map(function (_ref28) {
    var ReferenceNode = _ref28.ReferenceNode;
    return ReferenceNode;
  }), function (state, newState) {
    return _objectSpread(_objectSpread({}, state), newState);
  }).on(api.UserClassifier.fetchElementRefs.doneData.map(function (_ref29) {
    var items = _ref29.items;
    return items.map(adapter);
  }), updateByNodesArray).on(api.BimReference.create.doneData.map(adapter), updateItem).on(api.BimReference.move.doneData.map(adapter), updateItem).on(assemblyModelRef.map(adapter), updateItem).on(bulkCreated, function (state, _ref30) {
    var bimElementReferences = _ref30.bimElementReferences;

    var nextState = _objectSpread({}, state);

    bimElementReferences.map(adapter).forEach(function (reference) {
      nextState[reference.id] = _objectSpread({}, reference);
    });
    return nextState;
  }).on(childReferencesFetched.map(map(adapter)), function (state, nextNodes) {
    var toUpdate = nextNodes.filter(function (next) {
      var old = state[next.id]; // если ноды нет в сторе значит записываем

      if (!old) {
        return true;
      } // если у новой ноды версия классификатора больше или равна старой, значит перезаписываем


      if (old.parentClassifierVersion <= next.parentClassifierVersion) {
        return true;
      } // в противном случае оставляем в сторе старый реф (для избежания записи в стор неактуальных parentClassifierVersion)


      return false;
    });

    if (toUpdate.length === 0) {
      return state;
    }

    return updateChildItems(state, toUpdate);
  }).on(created.map(adapter).filter({
    fn: n.isReferenceNode
  }), updateItem).on(updated.map(adapter).filter({
    fn: n.isReferenceNode
  }), updateItem).on(assemblyModelRef.map(adapter), updateItem).on(removeRefFromGroup, function (state, children) {
    if (!children) {
      return state;
    }

    var newState = _objectSpread({}, state);

    children.forEach(function (child) {
      if (newState[child.id]) {
        delete newState[child.id];
      }
    });
    return newState;
  }) // TODO выпилить после GT-1190 Front: убрать постоянные перезапросы most-recent в приложениях
  // в GT-1193 Front: Очистить подписки в nodes$ classifier-service от дублирующегося кода
  .on(api.UserClassifier.removeDependency.done, function (state, data) {
    var references = Object.values(state);
    var clsReferences = references.filter(function (_ref31) {
      var source = _ref31.source;
      return (source === null || source === void 0 ? void 0 : source.sourceClassifierId) === data.params.sourceClassifierId;
    });

    if (clsReferences.length) {
      var nextState = _objectSpread({}, state);

      clsReferences.forEach(function (_ref32) {
        var id = _ref32.id;
        delete nextState[id];
      });
      return nextState;
    }

    return state;
  }).on(updated.map(adapter).filter({
    fn: n.isUserClassifierNode
  }), function (state, userClassifier) {
    var classifierChildRefs = Object.values(state).filter(function (_ref33) {
      var parentClassifierId = _ref33.parentClassifierId;
      return parentClassifierId === userClassifier.id;
    });

    if (classifierChildRefs.length) {
      var nextState = _objectSpread({}, state);

      classifierChildRefs.filter(function (_ref34) {
        var parentClassifierVersion = _ref34.parentClassifierVersion;
        return userClassifier.version > parentClassifierVersion;
      }).forEach(function (reference) {
        nextState[reference.id] = _objectSpread(_objectSpread({}, reference), {}, {
          parentClassifierVersion: userClassifier.version
        });
      });
      return nextState;
    }

    return state;
  }).on(removeAssemblyRef, removeItem).on(api.BimReference.remove.doneData.map(adapter), removeItem).on(removed.map(adapter).filter({
    fn: n.isReferenceNode
  }), removeItem).on(sourceRemoved, function (state, sourceCls) {
    var refs = Object.values(state);
    var toRemoveRefs = refs.filter(function (reference) {
      var _reference$source2;

      return ((_reference$source2 = reference.source) === null || _reference$source2 === void 0 ? void 0 : _reference$source2.sourceClassifierId) === sourceCls.id;
    }); // Удаляем рефы удаленного классификатора

    if (toRemoveRefs.length) {
      return toRemoveRefs.reduce(function (acc, reference) {
        delete acc[reference.id];
        return acc;
      }, _objectSpread({}, state));
    }

    return state;
  }).reset(reset);
  bimModel.nodes$.on(dependencies.update.doneData.map(function (_ref35) {
    var BimModelNode = _ref35.BimModelNode;
    return BimModelNode;
  }), function (state, newState) {
    return _objectSpread(_objectSpread({}, state), newState);
  }).on(api.BimModel.Populated.fetch.doneData.map(adapter), updateItemWithChildren).on(assemblyModelRef, function (state, node) {
    return updateItem(state, adapter(node.element));
  }) //После удаления рефа assembly удаляем элемент на который он ссылался
  //GT-559 Создать сборку из 3х моделей -> Удалить одну из моделей -> Собрать заново -> Если не перезагружать страницу после удаления модели из зависимости то в следующей сборке остаются элементы уже не участвующей в сборке модели
  .on(removeAssemblyRef, function (state, _ref36) {
    var element = _ref36.element;
    var node = state[element.id];

    if ((node === null || node === void 0 ? void 0 : node.type) === element.type) {
      var newState = _objectSpread({}, state);

      delete newState[element.id];
      return newState;
    }

    return state;
  }).on(incomingUpdated.filter({
    fn: api.BimModel.isLoadedOrNotLoaded
  }).map(adapter), function (state, model) {
    // Внимание!!!!!
    // Модель обновляется только если в сторе найдена та же модель и с той же версией (п.9 замечаний)
    var oldModel = state[model.id];

    if (oldModel && oldModel.version === model.version) {
      return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, model.id, model));
    }

    return state;
  }).on(childReferencesFetched.filterMap(function (references) {
    var referenceNodes = references.filter(api.BimReference.Model.is).map(prop('element')).map(adapter);

    if (referenceNodes.length) {
      return referenceNodes;
    }
  }), function (nodes, bimModelNodes) {
    // Если модель версии выше обновляем её вместе с детьми
    if (!bimModelNodes.some(function (model) {
      var _nodes$model$id;

      return nodes[model.id] && ((_nodes$model$id = nodes[model.id]) === null || _nodes$model$id === void 0 ? void 0 : _nodes$model$id.version) !== model.version;
    })) {
      return updateChildItems(nodes, bimModelNodes);
    }

    var newNodes = _objectSpread({}, nodes);

    bimModelNodes.forEach(function (model) {
      var _newNodes$model$id;

      if (newNodes[model.id] && ((_newNodes$model$id = newNodes[model.id]) === null || _newNodes$model$id === void 0 ? void 0 : _newNodes$model$id.version) !== model.version) {
        delete newNodes[model.id];
      }
    });
    return updateChildItems(newNodes, bimModelNodes);
  }).reset(reset);
  bimCategory.nodes$.on(dependencies.update.doneData.map(function (_ref37) {
    var BimCategoryNode = _ref37.BimCategoryNode;
    return BimCategoryNode;
  }), function (state, newState) {
    return _objectSpread(_objectSpread({}, state), newState);
  }).on(api.BimCategory.Populated.fetch.doneData.map(adapter), updateItemWithChildren).on(api.BimModel.Populated.fetch.doneData.map(prop('children')).map(map(adapter)), updateChildItems).on(childReferencesFetched.filterMap(function (references) {
    var referenceNodes = references.filter(api.BimReference.Category.is).map(prop('element')).map(adapter);

    if (referenceNodes.length) {
      return referenceNodes;
    }
  }), updateChildItems).reset(reset);
  bimFamily.nodes$.on(dependencies.update.doneData.map(function (_ref38) {
    var BimFamilyNode = _ref38.BimFamilyNode;
    return BimFamilyNode;
  }), function (state, newState) {
    return _objectSpread(_objectSpread({}, state), newState);
  }).on(api.BimFamily.Populated.fetch.doneData.map(adapter), updateItemWithChildren).on(api.BimCategory.Populated.fetch.doneData.map(prop('children')).map(map(adapter)), updateChildItems).on(childReferencesFetched.filterMap(function (references) {
    var referenceNodes = references.filter(api.BimReference.Family.is).map(prop('element')).map(adapter);

    if (referenceNodes.length) {
      return referenceNodes;
    }
  }), updateChildItems).reset(reset);
  bimStandardSize.nodes$.on(dependencies.update.doneData.map(function (_ref39) {
    var BimStandardSizeNode = _ref39.BimStandardSizeNode;
    return BimStandardSizeNode;
  }), function (state, newState) {
    return _objectSpread(_objectSpread({}, state), newState);
  }).on(api.BimStandardSize.Populated.fetch.doneData.map(adapter), updateItemWithChildren).on(api.BimElement.fetchByIds.doneData.map(map(adapter)), function (state, bimElementNodes) {
    var nextState = _objectSpread({}, state);

    var childrenMap = {};
    bimElementNodes.forEach(function (node) {
      var children = childrenMap[node.standardSizeId] || [];
      children.push({
        type: 'BimElementNode',
        id: node.id
      });
      childrenMap[node.standardSizeId] = children;
    });
    Object.entries(childrenMap).forEach(function (_ref40) {
      var _ref41 = _slicedToArray(_ref40, 2),
          standardSizeIdStr = _ref41[0],
          children = _ref41[1];

      var standardSizeId = Number(standardSizeIdStr);
      var node = state[standardSizeId];

      if (node) {
        nextState[standardSizeId] = _objectSpread(_objectSpread({}, node), {}, {
          children: children
        });
      }
    });
    return nextState;
  }).on(api.BimFamily.Populated.fetch.doneData.map(prop('children')).map(map(adapter)), updateChildItems).on(childReferencesFetched.filterMap(function (references) {
    var referenceNodes = references.filter(api.BimReference.StandardSize.is).map(prop('element')).map(adapter);

    if (referenceNodes.length) {
      return referenceNodes;
    }
  }), updateChildItems).reset(reset);
  bimElement.nodes$.on(dependencies.update.doneData.map(function (_ref42) {
    var BimElementNode = _ref42.BimElementNode;
    return BimElementNode;
  }), function (state, newState) {
    return _objectSpread(_objectSpread({}, state), newState);
  }).on(merge([api.UserClassifier.findAllElementsByFilter.doneData, api.UserClassifier.findElementEverywhere.doneData], {
    sid: "-sozxc5"
  }), function (state, result) {
    var nextState = _objectSpread({}, state);

    result.elements.forEach(function (element) {
      return nextState[element.id] = adapter(element);
    });
    return nextState;
  }).on(bulkCreated, function (state, _ref43) {
    var bimElementReferences = _ref43.bimElementReferences;

    var nextState = _objectSpread({}, state);

    bimElementReferences.map(function (ref) {
      return adapter(ref.element);
    }).forEach(function (element) {
      nextState[element.id] = _objectSpread({}, element);
    });
    return nextState;
  }).on(api.BimElement.fetchByIds.doneData.map(map(adapter)), function (state, items) {
    var nextState = _objectSpread({}, state);

    items.forEach(function (element) {
      nextState[element.id] = _objectSpread({}, element);
    });
    return nextState;
  }).on(api.BimElement.fetch.doneData.map(adapter), updateItem).on(api.UserClassifier.getElementFromViewer.doneData.map(adapter), updateItem).on(api.BimStandardSize.Populated.fetch.doneData.map(prop('children')).map(map(adapter)), updateChildItems).on(childReferencesFetched.filterMap(function (references) {
    var referenceNodes = references.filter(api.BimReference.Element.is).map(prop('element')).map(adapter);

    if (referenceNodes.length) {
      return referenceNodes;
    }
  }), updateChildItems).on(api.DynamicGroup.fetch.doneData, function (state, payload) {
    var next = _objectSpread({}, state);

    var refs = payload.children.filter(api.DynamicBimElementReference.is);
    refs.map(function (r) {
      return r.element;
    }).forEach(function (el) {
      next[el.id] = adapter(el);
    });
    return next;
  }).reset(reset);
  var anyRequestError = merge([api.BimModel.Populated.fetch.failData, api.BimCategory.Populated.fetch.failData, api.BimFamily.Populated.fetch.failData, api.BimStandardSize.Populated.fetch.failData, api.UserClassifier.fetch.failData, api.UserClassifier.create.failData, api.UserClassifier.copy.failData, api.UserClassifier.rename.failData, api.UserClassifier.move.failData, api.UserClassifier.remove.failData, api.UserClassifier.addDependency.failData, api.UserClassifier.removeDependency.failData, api.UserClassifier.renameVersion.failData, api.UserClassifier.removeVersionName.failData, api.UserClassifier.fetchNamedVersions.failData, api.UserClassifier.fetchVersionByDate.failData, api.UserClassifier.fetchVersionDates.failData, api.UserClassifier.findAllElementsByFilter.failData, api.UserClassifier.fetchFlatListDependencies.failData, api.UserClassifier.findElementEverywhere.failData, api.AssemblyClassifier.fetch.failData, api.AssemblyClassifier.create.failData, api.AssemblyClassifier.copy.failData, api.AssemblyClassifier.rename.failData, api.AssemblyClassifier.move.failData, api.AssemblyClassifier.remove.failData, api.AssemblyClassifier.addDependency.failData, api.AssemblyClassifier.removeDependency.failData, api.AssemblyClassifier.renameVersion.failData, api.AssemblyClassifier.removeVersionName.failData, api.AssemblyClassifier.fetchNamedVersions.failData, api.AssemblyClassifier.fetchVersionByDate.failData, api.AssemblyClassifier.fetchVersionDates.failData, api.AssemblyClassifier.fetchSourceModels.failData, api.DependencyWithModels.getClassifierDependencyModels.failData, api.DependencyWithModels.getAssemblyDependencyModels.failData, api.UserClassifierGroup.fetch.failData, api.UserClassifierGroup.create.failData, api.UserClassifierGroup.createGroupReference.failData, api.UserClassifierGroup.rename.failData, api.UserClassifierGroup.move.failData, api.UserClassifierGroup.remove.failData, api.UserClassifierGroup.createFilter.failData, api.UserClassifierGroup.updateFilter.failData, api.UserClassifierGroup.removeFilter.failData, api.DynamicGroup.create.failData, api.DynamicGroup.fetch.failData, api.DynamicGroup.remove.failData, api.DynamicGroup.updateCondition.failData, api.BimReference.create.failData, api.BimReference.move.failData, api.BimReference.remove.failData, api.BimReference.createRefs.failData, api.BimReference.moveRefs.failData, api.Auth.login.failData, api.BaseClassifier.Populated.fetch.failData], {
    name: "anyRequestError",
    sid: "r2ythk"
  });
  var anyRequestFail = anyRequestError.filter({
    fn: isJsendBadResultFail
  }).map(function (res) {
    var _res$data;

    var errorCode = res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.errorCode;

    if (errorCode in options.apiErrMessageMap) {
      return {
        mappedMessage: "".concat(options.apiErrMessageMap[errorCode]),
        res: res,
        errorCode: errorCode
      };
    }

    return {
      mappedMessage: null,
      res: res,
      errorCode: errorCode
    };
  });
  var anyRequestIOTSError = anyRequestError.filter({
    fn: isIOTSErrorResult
  });
  return {
    reset: reset,
    Gate: Gate,
    nodes$: nodes$,
    bimModel: bimModel,
    bimCategory: bimCategory,
    bimFamily: bimFamily,
    bimStandardSize: bimStandardSize,
    bimElement: bimElement,
    reference: reference,
    baseClassifier: baseClassifier,
    userClassifier: userClassifier,
    userClassifierGroup: userClassifierGroup,
    assemblyClassifier: assemblyClassifier,
    dynamicBaseGroup: dynamicBaseGroup,
    notification: notification,
    sourceRemoved: sourceRemoved,
    nodeCreated: nodeCreated,
    nodeUpdated: nodeUpdated,
    nodeRemoved: nodeRemoved,
    dependencies: dependencies,
    anyRequestFail: anyRequestFail,
    anyRequestIOTSError: anyRequestIOTSError
  };
}

function createNodeService(options) {
  var domain = options.parentDomain.domain(options.name, {
    name: "domain",
    sid: "-224ayj"
  });
  var nodes$ = domain.store({}, {
    ɔ: {
      name: 'nodes'
    },
    name: "nodes$",
    sid: "ul5uj6"
  });

  var useNode = function useNode(nodeId) {
    return useStoreMap({
      store: nodes$,
      keys: [nodeId],
      fn: function fn(nodes, _ref44) {
        var _ref45 = _slicedToArray(_ref44, 1),
            id = _ref45[0];

        return typeof id == 'number' ? nodes[id] || null : null;
      }
    });
  };

  return {
    nodes$: nodes$,
    useNode: useNode
  };
}

export function getChildren(nodes, parentNode) {
  var refs = parentNode.children || [];
  return refs.map(function (ref) {
    return getNode(nodes, ref);
  }).filter(isNotEmpty);
}
export function getNode(nodes, ref) {
  var nodeMapName = baseTypesMap[ref.type];
  var nodeMap = nodes[nodeMapName]; // eslint-disable-next-line no-shadow

  var node = nodeMap[ref.id]; // eslint-disable-next-line @typescript-eslint/no-explicit-any

  return node || null;
}
export function getReferenceByNode(nodes, ref) {
  var refMap = nodes.ReferenceNode;
  var reference = Object.values(refMap).find(function (refNode) {
    return refNode.element.type === ref.type && refNode.element.id === ref.id && refNode.parentClassifierId === ref.classifierId && refNode.parentClassifierVersion === ref.classifierVersion;
  });
  return reference || null;
}

var toGroupWithElements = function toGroupWithElements(source) {
  return {
    type: 'UserClassifierGroupWithElementsNode',
    id: source.id,
    parentClassifierId: source.parentClassifierId,
    parentClassifierVersion: source.parentClassifierVersion,
    parentGroupId: source.parentGroupId,
    name: source.name,
    children: [],
    offset: 0,
    total: 0,
    source: source.source,
    dynamicGroup: source.dynamicGroup,
    filterCondition: source.filterCondition
  };
}; // eslint-disable-next-line @typescript-eslint/no-unused-vars


var toGroupWithGroups = function toGroupWithGroups(source) {
  return {
    type: 'UserClassifierGroupWithGroupsNode',
    id: source.id,
    parentClassifierId: source.parentClassifierId,
    parentClassifierVersion: source.parentClassifierVersion,
    parentGroupId: source.parentGroupId,
    name: source.name,
    children: [],
    offset: 0,
    total: 0,
    source: source.source,
    dynamicGroup: source.dynamicGroup,
    filterCondition: source.filterCondition
  };
};

function updateByNodesArray(nodes, newNodes) {
  var state = _objectSpread({}, nodes);

  newNodes.forEach(function (node) {
    state = _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, node.id, node));
  });
  return state;
}